/**
 * Created by Claude on 27.01.2026
 */

const ArkadiumLogic = function () {
    PlatformLogic.call(this);
};

ArkadiumLogic.prototype = Object.create(PlatformLogic.prototype);
ArkadiumLogic.prototype.constructor = ArkadiumLogic;

ArkadiumLogic.prototype.reportScore = function (score, callback) {
    ArkadiumSDK.lifecycle.onChangeScore(score)
        .then(() => callback(connector.CODE_SUCCEED))
        .catch(() => callback(connector.CODE_FAILED));
};

ArkadiumLogic.prototype.reportLevelUp = function () {
    if (!cleverapps.gameLevel) {
        return;
    }

    const level = cleverapps.gameLevel.getLevel();

    connector.platform.gameplayStop(level - 1);
    connector.platform.gameplayStart(level);
};
